module.exports = __webpack_public_path__ + "img/Unidad18-2.823f3916.png";